import { Button, ButtonGroup, Label } from "reactstrap"

export const DEFAULT_STATUS_OPTIONS = [
  { value: "pending", label: "Pending", color: "warning", icon: "bx-time-five" },
  { value: "completed", label: "Completed", color: "success", icon: "bx-check-circle" },
  { value: "cancelled", label: "Cancelled", color: "secondary", icon: "bx-x-circle" },
]

const StatusButtonGroup = ({
  name = "status",
  label = "Status",
  value,
  onChange,
  options = DEFAULT_STATUS_OPTIONS,
  required = false,
  disabled = false,
  size = "sm",
  className = "mb-3",
}) => {
  return (
    <div className={className}>
      {label ? (
        <Label className="d-block">
          {label}
          {required ? <span className="text-danger"> *</span> : null}
        </Label>
      ) : null}
      <ButtonGroup size={size} className="d-flex flex-wrap">
        {options.map(opt => {
          const isActive = String(value) === String(opt.value)
          return (
            <Button
              key={opt.value}
              type="button"
              color={isActive ? opt.color : "light"}
              outline={!isActive}
              disabled={disabled}
              onClick={() => {
                if (onChange) onChange(opt.value)
              }}
            >
              {opt.icon ? (
                <i className={`bx ${opt.icon} me-1`} />
              ) : null}
              {opt.label}
            </Button>
          )
        })}
      </ButtonGroup>
      <input type="hidden" name={name} value={value || ""} />
    </div>
  )
}

export default StatusButtonGroup
